import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder,UntypedFormGroup,FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AutotextService } from 'src/app/autotext.service';
import {ExamsService} from '../../exams.service';
import { CardioService } from '../cardio.service';

@Component({
    selector: 'app-cardio-doppler',
    templateUrl: './cardio-doppler.component.html',
    styleUrls: ['./cardio-doppler.component.scss'],
    standalone: false
})
export class CardioDopplerComponent implements OnInit, OnDestroy {
  doppler: UntypedFormGroup;
  groups = ['Mitral','Tricuspid','Aortic','Pulmonic'];
  mediaSub: Subscription;
console = console
  constructor(public es: ExamsService, private fb:UntypedFormBuilder, public atS:AutotextService, public cardioS:CardioService) { 
    let forms = {
      TricuspidEPP: [''],
      PISA:[''],
      RAP:[''],
      VENACONTRACTA: [''],
      LVOTDiam:[''],
      LVOTTrace:[''],
      LVOTEnv:[''],
      LVOTVTI:[''],
      HR:[''],
      LVSV:[''],
      LVCO:[''],
      Ewave:[''],
      Awave:[''],
      EA:[''],
      DecT:[''],

    };
    for(let g of this.groups){
      forms[g+'PV'] = ['']
      forms[g +'PG'] = ['']
      forms[g +'MG'] = ['']
      forms[g +'VA'] = ['']
      forms[g +'RFV'] = ['']
      forms[g +'Stenosis'] = ['']
      forms[g +'Regurgitation'] = ['']
    }
    // Valve-specific extras, not part of the shared per-group set above:
    // MitralRPG -- MR (regurgitant) peak gradient, the regurgitant counterpart to MitralPG.
    //   Mitral only: AR severity is graded by pressure half-time/vena contracta, never by a
    //   gradient, so there is deliberately no Aortic equivalent.
    // AorticVTI -- aortic valve VTI (used for stroke volume). Aortic only. NB: `MitralVTI`
    //   already exists elsewhere as the MR PISA jet's VTI -- a different measurement.
    forms['MitralRPG'] = ['']
    forms['AorticVTI'] = ['']
    // MR PISA quantification. These three DB columns and their SR extraction already existed --
    // they were simply never surfaced in the GUI, so the extracted values were invisible.
    forms['MitralPISARadius'] = ['']
    forms['MitralVTI'] = ['']
    forms['MitralEROA'] = ['']
    forms['Mitral'] =[''];
    forms['Tricuspid'] =[''];
    forms['Aortic'] =[''];
    forms['Pulmonic'] =[''];
    forms['LVOT'] =[''];
    forms['LV'] = ['']

    
    this.doppler = fb.group(forms);

  }

  ngOnInit() {
    this.es.fillForm(this.doppler,"cardioDoppler",false,true);
    this.es.getSRs();
    
    if(!this.es.isClosed)
      this.mediaSub =  this.es.mediaArrived$.subscribe((mediatype)=>{
        if(mediatype == 'html')
          this.es.fillForm(this.doppler,"cardioDoppler",false,true);
      });

  }

  ngOnDestroy(): void {
      if(this.mediaSub)
        this.mediaSub.unsubscribe();
  }

}
